import React from "react"
import { Link } from "gatsby"
import * as Icon from "react-feather"
import Layout from "../components/_App/layout"
import Seo from "../components/_App/seo"
import Navbar from "../components/_App/Navbar"
import Footer from "../components/_App/Footer"
import PageBanner from "../components/Common/PageBanner"
import creativeServices from "../data/creative-services"

const ServicesPage = () => (
  <Layout>
    <Navbar />

    <PageBanner pageTitle="Our Creative Services" />

    <div className="services-area-two pt-80 pb-50 bg-f9f6f6">
      <div className="container">
        <div className="section-title">
          <h2>What We Do</h2>
          <div className="bar"></div>
          <p>
            From design to the final cut, our creative team helps brands look
            great and tell their story across every platform.
          </p>
        </div>

        <div className="row justify-content-center">
          {creativeServices.map(service => {
            const ServiceIcon = Icon[service.icon] || Icon.Star
            return (
              <div className="col-lg-4 col-sm-6" key={service.slug}>
                <div className="single-services-box">
                  <div className={`icon ${service.iconBg}`}>
                    <ServiceIcon />
                  </div>
                  <h3>
                    <Link to={`/services/${service.slug}`}>{service.title}</Link>
                  </h3>
                  <p>{service.summary}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>

    <div className="cta-area ptb-80">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-md-6">
            <div className="cta-content">
              <h3>Have a project in mind? Let's create something great.</h3>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div className="cta-right-content">
              <div className="buy-btn">
                <Link to="/contact" className="btn btn-primary">
                  Get a Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </Layout>
)

export const Head = () => <Seo title="Services" />

export default ServicesPage
